export const FULL_MONTH = 'MMMM';
export const MONTH_DAY = 'M/d';
export const MONTH_DAY_YEAR_HOUR_MINUTE = 'MM-dd-y HH:mm';
export const MONTH_DAY_YEAR = 'MM-dd-y';
export const MONTH_DAY_YEAR_SLASH = 'MM/dd/y';

export const UTC = 'UTC';
